import { Container, DialogContent, Grid } from "@material-ui/core";
import { useEffect, useState } from "react";

import BusRepository from "../../repositories/busRepository";
import BusFilter from "./BusFilter";
import BusList from "./BusList";
import CarFilter from "./CarFilter";
import CarList from "./CarList";
import FlightFilter from "./FlightFilter";
import FlightList from "./FlightList";
import HotelFilter from "./HotelFilter";
import HotelList from "./HotelList";

import {
  Button,
  Dialog,
  DialogActions,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";

import { format, parseISO } from "date-fns";
import { useHistory } from "react-router";
import CarRepository from "../../repositories/carRepository";
import { getExperiences } from "../../repositories/getExperiences";
import getFlights from "../../repositories/getFlights";
import HotelRepository from "../../repositories/hotelRepository";
import { ThemeButton } from "../ThemeButton/styles";
import EntertainmentFilter from "./EntertainmentFilter";
import EntertainmentList from "./EntertainmentList";
import ExperienceFilter from "./ExperienceFilter";
import ExperienceList from "./ExperienceList";
import HotelMap from "./HotelMap";
import NotFoundTrip from "./NotFoundTrip";
import "./default.css"; // theme css file

const SearchContent = ({ searchState, buscaAtual }) => {
  let history = useHistory();
  const theme = useTheme();
  const downOfSm = useMediaQuery(theme.breakpoints.down("sm"));

  const [filter, setFilter] = useState({});
  const [open, setOpen] = useState(false);

  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState();
  const busRepository = new BusRepository();
  const hotelRepository = new HotelRepository();
  const carRepository = new CarRepository();

  const S = require("./styles");
  const changeFilter = (filters) => {
    setFilter({ ...filter, filters });
  };

  const searchFlights = (search) => {
    setLoading(true);

    let flight = {
      qtAdult: search.adultos,
      qtChild: search.criancas,
      qtBaby: search.bebes,
      directFlight: search.apenasVoosDiretos,
      luggage: search.tarifasBagagem,
    };

    if (search.idavolta) {
      flight = Object.assign(flight, {
        flightSegments: [
          {
            departureAirport: search.origem.iata,
            arrivelAirport: search.destino.iata,
            departureDate: search.datas.startDate,
          },
          {
            departureAirport: search.destino.iata,
            arrivelAirport: search.origem.iata,
            departureDate: search.datas.endDate,
          },
        ],
      });
    } else {
      flight = Object.assign(flight, {
        flightSegments: [
          {
            departureAirport: search.origem.iata,
            arrivelAirport: search.destino.iata,
            departureDate: search.datas.startDate,
          },
        ],
      });
    }

    // Debug: Log payload antes de enviar
    console.log('[DEBUG] Flight Search Payload:', JSON.stringify(flight, null, 2));

    getFlights(flight)
      .then((res) => {
        console.log('[DEBUG] Flight Search Success:', res.status);
        setResults(res.data);
        setLoading(false);
      })
      .catch((error) => {
        console.error('[DEBUG] Flight Search Error:', {
          status: error?.response?.status,
          statusText: error?.response?.statusText,
          data: error?.response?.data,
          headers: error?.response?.headers,
          message: error?.message
        });
        switch (error?.response?.status) {
          case 400:
            history.push("/session-expires");
            break;
          case 401:
            history.push("/session-expires");
            break;
          case 409:
            setError(error?.response?.data?.error);
            break;
          default:
            break;
        }
        setLoading(false);
      });
  };

  const searchHotels = (search) => {
    setLoading(true);

    const occupancy = search.apartments
      ? search.apartments.map((apt) => ({
          adults: (apt.adults || 0) + (apt.seniors || 0),
          children: apt.childs || apt.children || 0,
          childrenAges: apt.childsAge || apt.childrenAges || [],
        }))
      : [
          {
            adults: search.qtAdult || 1,
            children: search.qtChild || 0,
            childrenAges: search.childAge || [],
          },
        ];

    const searchData = {
      start: format(new Date(search.datas.startDate), "yyyy-MM-dd"),
      end: format(new Date(search.datas.endDate), "yyyy-MM-dd"),
      occupancy: occupancy,
    };

    const searchPromise = hotelRepository.searchByDestination({
      ...searchData,
      destination: search.cidade.code,
    });

    searchPromise
      .then((res) => {
        const hotelAvails = res.data?.hotelAvails || [];

        if (res.status === 204 || !res.data || hotelAvails.length === 0) {
          setResults({
            hotelStays: [],
            error: true,
          });
        } else {
          console.log(hotelAvails);
          const mappedResults = {
            hotelStays: hotelAvails.map((hotelAvail) => {
              const hotel = hotelAvail.hotel;
              const allRooms = (hotelAvail.roomGroups || []).flatMap(
                (rg) => rg.rooms || [],
              );
              const minPrice = allRooms.reduce((min, room) => {
                const roomPrice =
                  room.cashPrice || room.fares?.[0]?.price?.amount || 0;
                return roomPrice > 0 && (min === 0 || roomPrice < min)
                  ? roomPrice
                  : min;
              }, 0);
              return {
                price: {
                  amountAfterTax: minPrice,
                  amountBeforeTax: minPrice,
                  currencyCode: "BRL",
                },
                basicPropertyInfo: {
                  hotelCode: hotel?.id,
                  hotelRef: {
                    hotelName: hotel?.name,
                  },
                  imageURL:
                    hotel?.images?.[0]?.large ||
                    hotel?.images?.[0]?.medium ||
                    "",
                  award: {
                    rating: hotel?.stars,
                  },
                  address: {
                    addressLine: hotel?.address?.address,
                  },
                  position: hotel?.address?.coordinates,
                },
                hotelDescriptiveContent: {
                  hotelInfo: {
                    descriptions: {
                      descriptiveText:
                        hotel?.details?.description ||
                        hotel?.description ||
                        hotel?.shortDescription ||
                        hotel?.longDescription ||
                        hotel?.overview ||
                        hotel?.details?.shortDescription ||
                        hotel?.details?.longDescription ||
                        hotel?.details?.overview ||
                        hotelAvail?.description ||
                        "",
                      multimediaDescriptionsType: {
                        multimediaDescriptions: [
                          {
                            imageItemsType: {
                              imageItems: (
                                hotel?.images ||
                                hotel?.details?.images ||
                                []
                              ).map((img) => ({
                                url: {
                                  address: img.large || img.medium || img.small,
                                },
                              })),
                            },
                          },
                        ],
                      },
                    },
                    checkInHours: {
                      start: hotel?.checkInTime || hotel?.details?.checkInTime,
                      end: hotel?.checkOutTime || hotel?.details?.checkOutTime,
                    },
                    hotelAmenities: (
                      hotel?.facilities ||
                      hotel?.details?.facilities ||
                      []
                    ).flatMap((f) => {
                      if (f.items && f.items.length > 0) {
                        return f.items.map((item) => ({ hotelAmenity: item.name || item }));
                      }
                      if (f.name) {
                        return [{ hotelAmenity: f.name }];
                      }
                      return [];
                    }),
                  },
                },
                roomStays: {
                  roomTypes: (hotelAvail.roomGroups || []).flatMap(
                    (rg, rgIndex) =>
                      (rg.rooms || []).map((room) => ({
                        roomName: room.roomType?.name,
                        roomCode: room.roomType?.code,
                        roomDescription: room.roomType?.description,
                        roomKey: room.key,
                        roomID: room.key,
                        refToken: room.refToken,
                        key: room.key,
                        roomRates: [
                          {
                            total: {
                              currencyCode:
                                room.fares?.[0]?.price?.currency || "BRL",
                              amountAfterTax:
                                room.cashPrice ||
                                room.fares?.[0]?.price?.amount,
                            },
                            origTotal: {
                              currencyCode:
                                room.fares?.[0]?.price?.currency || "BRL",
                              amountAfterTax:
                                room.cashPrice ||
                                room.fares?.[0]?.price?.amount,
                            },
                            ratePlan: {
                              ratePlanName: room.fares?.[0]?.description,
                            },
                            ratePlans: {
                              mealPlanInfo: {
                                mealPlanDescription: room.boardType?.name || "",
                              },
                              cancelPenalties: (room.cancellationPolicies
                                ? [room.cancellationPolicies]
                                : []
                              ).map((policy) => ({
                                penaltyDescription: {
                                  description:
                                    policy?.description || policy?.text || "",
                                },
                              })),
                              mealsIncluded: (() => {
                                const code = (room.boardType?.code || "").toLowerCase();
                                const name = (room.boardType?.name || "").toLowerCase();
                                const isBreakfast = code.includes("breakfast") || code === "bb" || name.includes("café") || name.includes("breakfast");
                                const isHalfBoard = code === "hb" || name.includes("meia pensão") || name.includes("half board");
                                const isFullBoard = code === "fb" || name.includes("pensão completa") || name.includes("full board");
                                const isAllInclusive = code === "ai" || code.startsWith("ai_") || code.includes("all") || name.includes("all inclusive") || name.includes("all-inclusive");
                                return {
                                  breakfast: isBreakfast || isHalfBoard || isFullBoard || isAllInclusive,
                                  lunch: isFullBoard || isAllInclusive,
                                  dinner: isHalfBoard || isFullBoard || isAllInclusive,
                                  allInclusive: isAllInclusive,
                                };
                              })(),
                            },
                            cancellation: room?.cancellationPolicies,
                            mealPlan: room.boardType?.name,
                            description: room.roomType?.description,
                            roomStayCandidateRph: rgIndex,
                            refToken: room.refToken,
                            key: room.key,
                          },
                        ],
                        pointsPrice: room.pointsPrice,
                        cashPrice: room.cashPrice,
                        guestRoom: {
                          amenitiesType: {
                            roomAmenities: (room.facilities || []).map((f) => ({
                              roomAmenity: f.name,
                            })),
                          },
                          multimediaDescriptionsType: {
                            multimediaDescriptions: [
                              {},
                              {
                                imageItemsType: {
                                  imageItems: (room.images || []).map(
                                    (img) => ({
                                      url: {
                                        address:
                                          img.large || img.medium || img.small,
                                      },
                                    }),
                                  ),
                                },
                              },
                            ],
                          },
                        },
                      })),
                  ),
                },
                availability: {
                  start: hotelAvail.checkIn || search.datas.startDate,
                  end: hotelAvail.checkOut || search.datas.endDate,
                },
                _originalData: hotelAvail,
              };
            }),
            searchParams: res.data.searchParams,
          };
          setResults(mappedResults);
        }
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        switch (error?.response?.status) {
          case 400:
            setResults({
              hotelStays: [],
              error: true,
            });
            break;
          case 401:
            history.push("/session-expires");
            break;
          case 409:
            setError(error?.response?.data?.error);
            break;
          default:
            setResults({
              hotelStays: [],
              error: true,
            });
            break;
        }
        setLoading(false);
      });
  };

  const searchCars = (search) => {
    setLoading(true);

    const pickUpCity = search.cidadeRetirada;
    const dropOffCity = search.mesmoLocal ? search.cidadeRetirada : search.cidadeDevolucao;

    const filter = {
      pickUpDate: format(new Date(search.datas.startDate), "yyyy-MM-dd"),
      pickUpHour: search.horaRetirada,
      pickUpLocation: pickUpCity.id,
      pickUpLocationType: pickUpCity.type,
      pickUpLocationIata: pickUpCity.type === "A" ? (pickUpCity.iata || pickUpCity.name?.match(/\(([A-Z]{3})\)/)?.[1]) : undefined,
      dropOffDate: format(new Date(search.datas.endDate), "yyyy-MM-dd"),
      dropOffHour: search.horaDevolucao,
      dropOffLocation: dropOffCity.id,
      dropOffLocationType: dropOffCity.type,
      dropOffLocationIata: dropOffCity.type === "A" ? (dropOffCity.iata || dropOffCity.name?.match(/\(([A-Z]{3})\)/)?.[1]) : undefined,
      nationality: "BR",
      searchRadius: 100,
    };

    carRepository
      .search(filter)
      .then((res) => {
        const raw = res.data || {};
        const vehicleAvails = raw.vehicleAvails || [];
        const mapped = [];

        for (const group of vehicleAvails) {
          for (const vehicle of group.vehicles || []) {
            const fareOption = vehicle.fareOptions?.[0];
            if (!fareOption) continue;

            const getDetail = (type) =>
              vehicle.vehicleDetails?.find((d) => d.type === type);

            const formatCarAddress = (loc) => {
              const city = loc?.address?.city?.name;
              const street = loc?.address?.address;
              if (city && street) return `${city} - ${street}`;
              return city || street || loc?.name;
            };

            mapped.push({
              vehicleKey: vehicle.key || fareOption.key,
              refToken: fareOption.refToken,
              fareOptions: vehicle.fareOptions,
              totalAmount: fareOption.cashPrice,
              cashPrice: fareOption.cashPrice,
              pointsPrice: fareOption.pointsPrice,
              companyCode: vehicle.rentalCompany?.code,
              companyName: vehicle.rentalCompany?.name,
              urlLogoCompany: vehicle.rentalCompany?.logo,
              category: vehicle.code || getDetail("CATEGORY")?.name,
              categoryName: getDetail("CATEGORY")?.name || vehicle.class,
              model: vehicle.model || vehicle.name,
              capacity: getDetail("NR_PASSENGER")?.name,
              numberDoors: getDetail("NR_DOORS")?.name,
              transmissionName: getDetail("TRANSMISSION")?.name || null,
              automaticTransmission: getDetail("TRANSMISSION")?.name
                ?.toUpperCase()
                ?.includes("AUTO"),
              fuelName: getDetail("FUEL")?.name || null,
              airConditioning: !!getDetail("AIR_CONDITIONING"),
              fareKey: fareOption.fares?.[0]?.key || null,
              fareName: fareOption.fares?.[0]?.description || null,
              pickupShopName: vehicle.pickUpLocation?.name || null,
              dropoffShopName: vehicle.dropOffLocation?.name || null,
              pickupDateTime: vehicle.pickUpDate,
              dropoffDateTime: vehicle.dropOffDate,
              pickupAddress: formatCarAddress(vehicle.pickUpLocation),
              dropoffAddress: formatCarAddress(vehicle.dropOffLocation),
              urlCarImg: vehicle.images?.[0]?.large || vehicle.images?.[0]?.medium || vehicle.images?.[0]?.small,
              paidOnDestination: vehicle.additionalInformation?.paidOnDestination ?? null,
              loyaltyNumbersList: { discountNumbers: ["hub"] },
            });
          }
        }

        setResults(mapped);
        setLoading(false);
      })
      .catch((error) => {
        switch (error?.response?.status) {
          case 401:
            history.push("/session-expires");
            break;
          case 409:
            setError(error?.response?.data?.error);
            break;
          default:
            break;
        }
        setLoading(false);
      });
  };

  const searchExperiences = (search) => {
    setLoading(true);
    // US-18: cidade e data sao opcionais; US-19: filtros de categoria/subcategoria.
    const cityId = search?.cidade?.id;
    const startDate = search?.datas?.startDate
      ? format(new Date(search.datas.startDate), "yyyy-MM-dd")
      : undefined;
    const endDate = search?.datas?.endDate
      ? format(new Date(search.datas.endDate), "yyyy-MM-dd")
      : undefined;
    getExperiences(
      cityId,
      startDate,
      endDate,
      search?.categoria?.id,
      /* `subcategorias` (plural) vem do banner de Vitrine, que permite varias.
         `subcategoria` (singular) vem da barra de busca, que e de selecao unica. */
      search?.subcategorias?.length
        ? search.subcategorias.map((s) => s?.id).filter(Boolean)
        : search?.subcategoria?.id,
    )
      .then((res) => {
        // 204 (sem resultados) vem com corpo vazio -> normaliza para lista vazia
        setResults(Array.isArray(res.data) ? res.data : []);
        setLoading(false);
      })
      .catch((error) => {
        switch (error?.response?.status) {
          case 400:
            history.push("/session-expires");
            break;
          case 401:
            history.push("/session-expires");
            break;
          case 409:
            setError(error?.response?.data?.error);
            break;
          default:
            break;
        }
        setLoading(false);
      });
  };

  const searchBus = (search) => {
    setLoading(true);
    const DataIda = format(parseISO(search.datas.startDate), "yyyy-MM-dd");

    let bus = {
      DataIda,
      DataVolta: null,
      Origem: { id: search.origem.id },
      Destino: { id: search.destino.id },
      idavolta: search.idavolta,
      passageiros: search.passageiros,
      nacionalidade: search.nacionalidade,
    };

    if (search?.datas?.endDate) {
      bus.DataVolta = format(parseISO(search.datas.endDate), "yyyy-MM-dd");
    }

    busRepository
      .getBus(bus)
      .then((res) => {
        setResults(res);
        setLoading(false);
      })
      .catch((error) => {
        switch (error?.response?.status) {
          case 400:
            setError(error?.response?.data?.error);
            break;
          case 401:
            history.push("/session-expires");
            break;
          default:
            break;
        }
        setLoading(false);
      });
  };

  const searchEntertainment = (searchResults) => {
    setLoading(true);
    if (searchResults) {
      setResults(searchResults);
      setLoading(false);
    } else {
      console.error("Nenhum dado disponível.");
      setResults([]);
      setLoading(false);
    }
  };

  useEffect(() => {
    buscaAtual === "Aéreo" && searchState && searchFlights(searchState);
    buscaAtual === "Hotel" && searchState && searchHotels(searchState);
    buscaAtual === "Carro" && searchState && searchCars(searchState);
    buscaAtual === "Experiencias" &&
      searchState &&
      searchExperiences(searchState);
    buscaAtual === "Rodoviário" && searchState && searchBus(searchState);
    buscaAtual === "Entretenimento" &&
      searchState &&
      searchEntertainment(searchState);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [buscaAtual, searchState]);

  // o useEffect abaixo, é uma gambiarra que serve para renderizar os componentes em mobile, pois a lista de resultados não estava renderizando, independente das condicionais estarem corretas, porém, quando abre o modal, ele renderiza, então, abro o modal, e fecho ele, para renderizar os componentes
  useEffect(() => {
    if (downOfSm) {
      if (buscaAtual !== "Hotel")
        setTimeout(() => {
          setOpen(() => true);
          setOpen(() => false);
        }, 600);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [results]);
  return (
    <S.Wrapper>
      {!loading && error && (
        <Container>
          <S.NotFoundTrip>
            <span>{error}</span>
            <ThemeButton onClick={() => history.push("/")} className="pesquisa">
              Refazer pesquisa
            </ThemeButton>
          </S.NotFoundTrip>
        </Container>
      )}
      {!loading &&
        buscaAtual === "Aéreo" &&
        searchState &&
        results &&
        results.recommendations?.length === 0 && <NotFoundTrip />}
      {!loading &&
        buscaAtual === "Rodoviário" &&
        searchState &&
        results.length === 0 && <NotFoundTrip />}
      {!loading &&
        buscaAtual === "Experiencias" &&
        searchState &&
        results.length === 0 && <NotFoundTrip />}
      {!loading &&
        buscaAtual === "Entretenimento" &&
        searchState &&
        results.length === 0 && <NotFoundTrip />}
      {!loading &&
        buscaAtual === "Carro" &&
        searchState &&
        results.length === 0 && <NotFoundTrip />}
      {!loading && buscaAtual === "Pacote" && searchState && <NotFoundTrip />}
      {loading && buscaAtual === "Hotel" && (
        <S.Container>
          <S.ConstructionAnimation>
            <S.Hotel>
              <span className="moon"></span>
              <span className="star star-1"></span>
              <span className="star star-2"></span>
              <div className="roof"></div>
              <div className="facade">
                <div className="windows">
                  <div className="window"></div>
                  <div className="window"></div>
                  <div className="window"></div>
                  <div className="window"></div>
                  <div className="window"></div>
                  <div className="window"></div>
                  <div className="window"></div>
                  <div className="window"></div>
                  <div className="window"></div>
                </div>
                <div className="door"></div>
              </div>
            </S.Hotel>
            <S.ConstructionText>
              Construindo sua estadia perfeita...
            </S.ConstructionText>
            <S.ConstructionSubtext>
              Aguarde enquanto buscamos os melhores hotéis para você!
            </S.ConstructionSubtext>
          </S.ConstructionAnimation>
        </S.Container>
      )}
      {loading && buscaAtual === "Carro" && (
        <S.Container>
          <S.CarLoaderAnimation>
            <S.CarLoaderText>
              Aguarde enquanto buscamos os melhores preços para você!
            </S.CarLoaderText>
            <S.CarScene>
              <div className="car">
                <div className="cabin">
                  <div className="window" />
                  <div className="window" />
                </div>
                <div className="body">
                  <div className="headlight" />
                  <div className="taillight" />
                </div>
                <div className="wheel wheel-back" />
                <div className="wheel wheel-front" />
              </div>
              <div className="road" />
            </S.CarScene>
          </S.CarLoaderAnimation>
        </S.Container>
      )}
      {loading && buscaAtual !== "Hotel" && buscaAtual !== "Carro" && (
        <S.Container>
          <S.LoadText>
            Aguarde enquanto buscamos os melhores preços para você!
          </S.LoadText>
        </S.Container>
      )}
      <Dialog fullScreen={downOfSm} open={open} onClose={() => setOpen(false)}>
        <DialogContent>
          {buscaAtual === "Aéreo" && searchState && (
            <FlightFilter
              changeFilter={changeFilter}
              searchState={searchState}
              results={results}
              loading={loading}
              error={error}
              buscaAtual={buscaAtual}
            />
          )}
          {buscaAtual === "Carro" && searchState && (
            <CarFilter
              changeFilter={changeFilter}
              searchState={searchState}
              results={results}
              loading={loading}
              error={error}
              buscaAtual={buscaAtual}
            />
          )}
          {buscaAtual === "Hotel" && searchState && (
            <HotelFilter
              changeFilter={changeFilter}
              searchState={searchState}
              stays={results.hotelStays}
              loading={loading}
              error={error}
              buscaAtual={buscaAtual}
            />
          )}
          {buscaAtual === "Rodoviário" && searchState && (
            <BusFilter
              changeFilter={changeFilter}
              searchState={searchState}
              results={results}
              loading={loading}
            />
          )}
          {buscaAtual === "Entretenimento" && searchState && (
            <EntertainmentFilter
              changeFilter={changeFilter}
              loading={loading}
              activities={searchState.activities || []}
            />
          )}
        </DialogContent>

        <DialogActions>
          <Button autoFocus onClick={() => setOpen(false)} color="error">
            Cancelar
          </Button>
          <Button onClick={() => setOpen(false)} color="primary" autoFocus>
            Aplicar
          </Button>
        </DialogActions>
      </Dialog>
      <Container>
        <S.Content>
          <Grid container spacing={3}>
            {!downOfSm ? (
              <>
                {buscaAtual !== "Rodoviário" ? (
                  <Grid
                    item
                    md={3}
                    className={
                      (buscaAtual === "Entretenimento" && loading) ||
                      (buscaAtual === "Hotel" && loading)
                        ? "display-none"
                        : ""
                    }
                  >
                    {buscaAtual === "Aéreo" && searchState && results && (
                      <FlightFilter
                        changeFilter={changeFilter}
                        searchState={searchState}
                        results={results}
                        loading={loading}
                        error={error}
                        buscaAtual={buscaAtual}
                      />
                    )}
                    {buscaAtual === "Carro" &&
                      searchState &&
                      results.length > 0 && (
                        <CarFilter
                          changeFilter={changeFilter}
                          searchState={searchState}
                          results={results}
                          loading={loading}
                          error={error}
                          buscaAtual={buscaAtual}
                        />
                      )}
                    {buscaAtual === "Experiencias" && searchState && (
                      <ExperienceFilter
                        changeFilter={changeFilter}
                        searchState={searchState}
                        results={results}
                        loading={loading}
                        error={error}
                        buscaAtual={buscaAtual}
                      />
                    )}
                    {buscaAtual === "Entretenimento" && searchState && (
                      <EntertainmentFilter
                        changeFilter={changeFilter}
                        loading={loading}
                        activities={searchState.activities || []}
                      />
                    )}
                    {buscaAtual === "Hotel" && searchState && !loading && (
                      <HotelFilter
                        changeFilter={changeFilter}
                        searchState={searchState}
                        stays={results.hotelStays}
                        loading={loading}
                        error={error}
                        buscaAtual={buscaAtual}
                      />
                    )}
                  </Grid>
                ) : (
                  <Grid item md={2}>
                    {searchState && results && (
                      <BusFilter
                        changeFilter={changeFilter}
                        searchState={searchState}
                        results={results}
                        loading={loading}
                        error={error}
                        buscaAtual={buscaAtual}
                      />
                    )}
                  </Grid>
                )}
              </>
            ) : (
              <Button
                onClick={() => setOpen(true)}
                variant="contained"
                className="button-open-filter"
                autoFocus
                fullWidth
                startIcon={<SearchIcon />}
              >
                Aplicar filtros
              </Button>
            )}
            {buscaAtual === "Rodoviário" ? (
              <>
                {buscaAtual === "Rodoviário" && searchState && results && (
                  <BusList
                    busAvailability={results.busAvailability}
                    searchState={searchState}
                    loading={loading}
                    error={error}
                    filter={filter.filters}
                    buscaAtual={buscaAtual}
                  />
                )}
              </>
            ) : (
              <Grid
                item
                xs={12}
                md={
                  (buscaAtual === "Entretenimento" && loading) ||
                  (buscaAtual === "Hotel" && loading)
                    ? 12
                    : 9
                }
              >
                {buscaAtual === "Aéreo" && searchState && results && (
                  <FlightList
                    filters={filter.filters}
                    searchState={searchState}
                    recommendations={results.recommendations}
                    resumos={
                      results?.availabilitysummary?.availabilitysummarycarrier
                    }
                    loading={loading}
                    error={error}
                    buscaAtual={buscaAtual}
                  />
                )}
                {buscaAtual === "Carro" &&
                  searchState &&
                  results.length > 0 && (
                    <CarList
                      filters={filter}
                      searchState={searchState}
                      results={results}
                      loading={loading}
                      error={error}
                      buscaAtual={buscaAtual}
                    />
                  )}

                {buscaAtual === "Hotel" &&
                  searchState &&
                  results.hotelStays &&
                  !results.error &&
                  (filter.filters?.mapOrList ? (
                    <HotelMap
                      filters={filter.filters}
                      searchState={searchState}
                      stays={results.hotelStays}
                      loading={loading}
                      error={error}
                      buscaAtual={buscaAtual}
                    />
                  ) : (
                    <HotelList
                      filters={filter.filters}
                      searchState={searchState}
                      stays={results.hotelStays}
                      loading={loading}
                      error={error}
                      buscaAtual={buscaAtual}
                    />
                  ))}

                {buscaAtual === "Hotel" && results.error && <NotFoundTrip />}
                {buscaAtual === "Experiencias" && searchState && (
                  <ExperienceList
                    filters={filter}
                    searchState={searchState}
                    experiences={results}
                    loading={loading}
                    error={error}
                    buscaAtual={buscaAtual}
                  />
                )}
                {buscaAtual === "Entretenimento" && searchState && (
                  <EntertainmentList
                    filters={filter.filters}
                    loading={loading}
                    error={error}
                    searchState={searchState}
                  />
                )}
              </Grid>
            )}
          </Grid>
        </S.Content>
      </Container>
    </S.Wrapper>
  );
};

export default SearchContent;
